import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { toSelect } from 'utils/genericFunctions';
import { Types, ConsultarUnidades } from './types';

export const INITIAL_STATE: ConsultarUnidades = {
	status: 0,
	data: null,
	enum: [],
	totalRegistrosConsulta: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarUnidades {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_UNIDADES_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.CONSULTAR_UNIDADES_SUCCESS: {
				draft.enum = toSelect(action.payload.data, 'nome', 'id');
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				draft.totalRegistrosConsulta = action.payload.headers['x-total-count'];
				break;
			}

			case Types.CONSULTAR_UNIDADES_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CONSULTAR_UNIDADES_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			default:
		}
		return draft;
	});
}
